import { render } from "./LegalWarning.vue?vue&type=template&id=22fe9b22&scoped=true"
import script from "./LegalWarning.vue?vue&type=script&lang=js"
export * from "./LegalWarning.vue?vue&type=script&lang=js"

import "./LegalWarning.vue?vue&type=style&index=0&id=22fe9b22&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22fe9b22"]])

export default __exports__